export default "__VITE_ASSET__BSxFdwWY__"